import { Reveal } from "../components/Reveal";
import { IMG } from "../data/worlds";

export const Philosophy = () => (
  <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="philosophy-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal className="relative">
        <div className="blob floaty-slow" style={{ background: "rgba(58,123,213,0.1)", width: "105%", height: "100%", top: 0, left: "-4%" }} />
        <img
          src={IMG.moment}
          alt="Ein gemeinsamer Lesemoment zwischen Kind und Erwachsenem"
          className="relative w-full rounded-[28px] rotate-[-1.5deg]"
          style={{ boxShadow: "0 26px 60px rgba(44,43,40,0.18)" }}
        />
      </Reveal>
      <div>
        <Reveal>
          <p className="eyebrow-label mb-5">Unsere Philosophie</p>
          <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-8">
            Für kleine Entdecker.<br />Für gemeinsame <em style={{ color: "var(--terra)" }}>Momente.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed space-y-4 mb-8">
            <p>VisualMA soll Lernen nicht größer oder komplizierter machen.</p>
            <p>
              Wir möchten kleine, liebevoll gestaltete Momente schaffen, in denen Kinder zeigen,
              fragen, mitsingen und Neues entdecken können.
            </p>
          </div>
          <p className="font-display italic text-xl sm:text-2xl leading-relaxed">
            Ein Buch.<br />
            Ein Lied.<br />
            Ein gemeinsamer Moment.<br />
            <span style={{ color: "var(--terra)" }}>Eine neue kleine Welt.</span>
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
